import { TRAINER } from "../data";

export const Footer = () => (
  <footer className="border-t border-zinc-800 px-4 md:px-8 lg:px-12 py-16" data-testid="footer">
    <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-10">
      <div>
        <div className="font-display text-4xl md:text-6xl text-white leading-none">
          JURADO<span className="text-[#FF3B30]">.</span>PERFORMANCE
        </div>
        <p className="text-zinc-500 mt-4 max-w-sm">{TRAINER.role} — {TRAINER.location}. Complimentary consultations for new clients.</p>
      </div>
      <div className="flex flex-col md:items-end gap-2 text-sm">
        <a href={`mailto:${TRAINER.email}`} className="text-zinc-400 hover:text-[#FF3B30] transition-colors">{TRAINER.email}</a>
        <a href={`tel:${TRAINER.phone}`} className="text-zinc-400 hover:text-[#FF3B30] transition-colors">{TRAINER.phone}</a>
        <span className="text-zinc-600 mt-4">© {new Date().getFullYear()} {TRAINER.name}. All rights reserved.</span>
      </div>
    </div>
  </footer>
);
